/* eslint-disable @typescript-eslint/no-explicit-any */
import {FLIP_CARD_SIDE, IElementFlipCard, IFlipCardElements} from '../incase-domain/elements/flipCard';

export const updateFlipCardImage = (
    fields: string[],
    values: unknown[],
    element: IElementFlipCard,
    flipCardSide: FLIP_CARD_SIDE
): IElementFlipCard => {
    if (!element || !element.flipCardElement) {
        return element;
    }
    const flipCardElementToUpdate: any = {...element.flipCardElement[flipCardSide]};

    fields.forEach((field, index) => {
        flipCardElementToUpdate[field] = values[index];
    });

    const updatedFlipCardElement: Record<FLIP_CARD_SIDE, IFlipCardElements> = {
        ...element.flipCardElement,
        [flipCardSide]: flipCardElementToUpdate,
    };

    return {
        ...element,
        flipCardElement: updatedFlipCardElement,
    };
};
